

module.exports = __webpack_require__.stylable.create(
    "App1033828718",
    {"classes":{"root":"App1033828718__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "App1033828718",
    null
);
